import { useMemo, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnalyticsChatUI from './components/AnalyticsChatUI.jsx'
import LoginScreen from './components/auth/LoginScreen.jsx';

function App() {
  const [authUser, setAuthUser] = useState(() => {
    const cached = localStorage.getItem('contisoft_auth_user');
    return cached ? JSON.parse(cached) : null;
  });

  const isAuthenticated = useMemo(() => !!authUser?.email, [authUser]);

  const handleLoginSuccess = (user) => {
    setAuthUser(user);
    localStorage.setItem('contisoft_auth_user', JSON.stringify(user));
  };

  const handleLogout = () => {
    setAuthUser(null);
    localStorage.removeItem('contisoft_auth_user');
  };

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/chat" replace />
          ) : (
            <LoginScreen onLoginSuccess={handleLoginSuccess} />
          )
        }
      />
      <Route
        path="/chat"
        element={
          isAuthenticated ? (
            <AnalyticsChatUI onLogout={handleLogout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? '/chat' : '/login'} replace />}
      />
    </Routes>
  );

}

export default App

